export default {
	headerAssignment: 'Opravdu chcete převzít vybraný úkol(y)?',
	messageAssignment: 'Převzetím úkolu se změní řešitel úkolu.',
	informationAssigmentAll: 'Opravdu chcete zpracovat všechny informace?',
	headerSendAssignment: 'Opravdu si přejete vybrané úkoly předat zvolenému uživateli/skupině uživatelů?',
	sellerRequestCheckPS: 'Nebylo zadáno Číslo PS. Opravdu si přejete vytvořit úkol bez vazby na pojistnou smlouvu?',
	taskCreatingPagesNewTask: 'Opravdu si přejete vytvořit nový úkol pro zadaného řešitele?',
	taskCreatingPagesNewLead: 'Opravdu si přejete vytvořit novou příležitost pro zadaného řešitele?',
	campaignSettingsClear: 'Opravdu si přejete vymazat nastavení kampaně?',
	campaignSettingsChannelChange:
		'Na kampani došlo ke změně kanálu kampaně. Pokud kampaň uložíte, dojde k vymazání všech nastavených nominací. Přejete si pokračovat?',
	createNewManualLead: 'Opravdu si přejete vytvořit novou příležitost pro zadaného řešitele?',
	maximumContactColumnsExceeded: 'Je umožněno přidat pouze {{ count }} doplňujících sloupců.',
	productionControlNoticeStateId2:
		'Smlouva byla v platnosti více než 24 hodin, vztahuje se na ni archivační povinnost. Prosím o dodatečné oslovení klienta a zajištění podepsané smluvní dokumentace. Opravdu si přejete data uložit?',
	productionControlNoticeStateId3:
		'Smlouva je stornována, ale byla v systému aktivní po dobu 63 dnů. Smlouva musí být odevzdána nebo přestornována k počátku ve spolupráci se správou smluv. Opravdu si přejete data uložit?',
	confirmAssignment: 'Převzít',
	confirmSend: 'Předat',
	cancel: 'Zrušit',
};
